/**
 * Function to check permissions on each route
 *
 * @param {object} item         the route item
 * @param {object} permissions  the permissions object from the user auth call - permission name as key and array of permissions for the value e.g.: { PERMISSIONNAME: ['TYPES'...] }
 * @returns {object} object with filtered route item and its children
 */
const checkPermission = (item, permissions) => {
    if (!item.permissions) {
        return null;
    }

    const hasNecessaryPermission = (permissionItem) => {
        if (permissionItem.permissions) {
            // return items without specific permission that are always allowed
            if (permissionItem.permissions === true) {
                return permissionItem;
            }

            return !!Object.keys(permissionItem.permissions).find((key) => {
                return (
                    permissions[key] &&
                    permissions[key].includes(permissionItem.permissions[key])
                );
            });
        }
        return null;
    };

    if (!hasNecessaryPermission(item)) {
        return null;
    }

    const children = item.children.filter(hasNecessaryPermission);

    return {
        ...item,
        children
    };
};

export { checkPermission };
